// ---------------------------------------------------------------------------
// Canonical 1-9 NFL scouting grade scale.
// ---------------------------------------------------------------------------
// 9 — Rare        ·  generational
// 8 — Outstanding ·  Pro-Bowl ceiling
// 7 — Very Good   ·  high-end starter
// 6 — Good        ·  starter-level
// 5 — Average     ·  league-average / spot starter
// 4 — Below Avg.  ·  rotational / depth
// 3 — Marginal    ·  deep depth / camp body
// 2 — Poor        ·  practice squad ceiling
// 1 — Reject      ·  not a fit
// ---------------------------------------------------------------------------
export const GRADE_SCALE = [
  { value: 9, label: "Rare",        tone: "violet"  },
  { value: 8, label: "Outstanding", tone: "emerald" },
  { value: 7, label: "Very Good",   tone: "emerald" },
  { value: 6, label: "Good",        tone: "cyan"    },
  { value: 5, label: "Average",     tone: "cyan"    },
  { value: 4, label: "Below Avg.",  tone: "amber"   },
  { value: 3, label: "Marginal",    tone: "amber"   },
  { value: 2, label: "Poor",        tone: "rose"    },
  { value: 1, label: "Reject",      tone: "rose"    },
];

/**
 * Resolve the label + tone for a 1-9 score. Decimal scores round to nearest
 * integer (4.5 → 5 / Average; 6.4 → 6 / Good). Null/0/undefined returns the
 * "Ungraded" sentinel so callers can choose to render or skip.
 */
export function gradeLabel(score) {
  if (score == null || score === 0) {
    return { value: null, label: "Ungraded", tone: "neutral" };
  }
  const rounded = Math.max(1, Math.min(9, Math.round(Number(score))));
  return GRADE_SCALE.find((g) => g.value === rounded) || { value: rounded, label: "—", tone: "neutral" };
}

/**
 * Tailwind class fragments for the scale tones — kept here so the shape is
 * consistent everywhere the label is rendered.
 */
export const GRADE_TONE_CLASS = {
  violet:  "bg-violet-300/15 text-violet-200 ring-violet-300/30",
  emerald: "bg-emerald-300/15 text-emerald-200 ring-emerald-300/30",
  cyan:    "bg-cyan-300/15 text-cyan-200 ring-cyan-300/30",
  amber:   "bg-amber-300/15 text-amber-200 ring-amber-300/30",
  rose:    "bg-rose-400/15 text-rose-200 ring-rose-300/30",
  neutral: "bg-white/5 text-3 ring-white/10",
};
